const cache: { [key: string]: unknown } = {};

// returns the last value that is not null or undefined
export const getLastTruthyValue = <T>(key: string, value: T) => {
  if (value == null) return (cache[key] as T) ?? value;

  cache[key] = value;
  return value;
};
